import React from 'react'
import PropTypes from 'prop-types'

import {
  Button, Form, SidebarModal,
} from '@domain-group/suit-theme'

import useOrderBundle, { useOrderBundleForm } from '@hooks/useOrderBundle'

const CreateOrderBundleModal = (props) => {
  const { callbacks, modalKey = 'CreateOrderBundleModal', showModal } = props
  const { closeModal, createOrderBundle } = callbacks || {}

  const {
    entityState,
    entityState: {
      price,
      title,
    },
    errors,
    handlers,
    saveEnabled,
  } = useOrderBundleForm({}, { validateOn: 'change' })

  const {
    callbacks: { createOrderBundle: createFn },
    creating,
  } = useOrderBundle()

  const createOrderBundlePayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Bundle Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Bundle" />

      <SidebarModal.Content>
        <Form>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.price} label="* Price" marginTop="large">
            <input min="0" name="price" type="number" value={price} {...handlers} />
          </Form.Field>

          <Form.Field label="Global" marginTop="large">
            <select
              data-value-type="boolean"
              name="global"
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createOrderBundle(createOrderBundlePayload)}
          size="large"
        >
          {saveEnabled ? 'Create Bundle' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateOrderBundleModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateOrderBundleModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
